import { render, staticRenderFns } from "./SmimeCertificateModal.vue?vue&type=template&id=482b81be&scoped=true"
import script from "./SmimeCertificateModal.vue?vue&type=script&lang=js"
export * from "./SmimeCertificateModal.vue?vue&type=script&lang=js"
import style0 from "./SmimeCertificateModal.vue?vue&type=style&index=0&id=482b81be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b81be",
  null
  
)

export default component.exports